<template>
  <div class="login-wrap mt-5">
    <div class="container">
      <div class="row mx-0">
        <div class="col-md-3"></div>
        <div class="col-md-6">
          <div class="header-and-logo text-center mb-4">
            <h1 class="font-weight-bold">LOGIN</h1>
            <h2 class="font-weight-bold">PRIORITY LENDER</h2>
            <a class="mt-2" href="">
              <img src="@/assets/images/logogradana.png" class />
            </a>
          </div>

          <!-- V-SHOW START -->
          <div id="lgn-opt" class="row text-uppercase text-center border-bottom mb-4 mx-1 px-0 pb-2" style="font-size: larger;">
            <div class="login-opt row col-md-6 mx-0 text-center">
              <div class="col-md-12 py-1 px-0">
             
                <!-- <a href="#" class="router-link-exact-active router-link-active text-dark" 
                id="nav-email-tab" data-toggle="tab" style="text-decoration: none"
                  @click="toggleLoginForm('email')"
                >by email</a> -->
                
                <router-link
                  active-class="active"
                  id="nav-email-tab"
                  :to="{ name: 'emailLogin'}"
                >
                  by email
                </router-link>

              </div>
            </div>
            <div class="login-opt row col-md-6 mx-0 text-center">
              <div class="col-md-12 py-1">
                <!-- <a class="router-link-exact-active router-link-active text-dark" id="nav-phone-tab" data-toggle="tab" href="#" style="text-decoration: none"
                  @click="toggleLoginForm('phone')"
                >by phone</a> -->

                <router-link
                  active-class="active"
                  id="nav-email-tab"
                  :to="{ name: 'phoneLogin'}"
                >
                  by phone
                </router-link>

              </div>
              <div class="col-md-2"></div>
            </div>

            <div class="tab-content" id="myTabContent">
              <div class id="profile" role="tabpanel" aria-labelledby="nav-by-email"></div>
              <div class id="contact" role="tabpanel" aria-labelledby="nav-by-phone"></div>
            </div>
          </div>

          <div class="tab-content" id="nav-tabContent" style="font-size: larger;">
            <router-view></router-view>
          </div>
        </div>
        <div class="col-md-3"></div>
      </div>
    </div>
  </div>
</template>

<script>
import EmailLogin from "@/components/EmailLogin.vue";
import PhoneLogin from "@/components/PhoneLogin.vue";

export default {
  name: "login",
  components: {
    EmailLogin,
    PhoneLogin
  }
};
</script>

<style scoped>
#nav-email-tab {
  color: black;
}

#nav-email-tab.active {
  color: #007bff;
}
</style>